export type MemberError = {
  __typename: string;
  errors: {
    __typename?: string;
    message?: string;
  }[];
};

export type Member = {
  __typename: string;
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  assets: Partial<MemberAsset>[];
  identity: Partial<MemberIdentity> | null;
  salesForceAccount: Partial<MemberSalesforceAccount> | null;
};

export type MemberIdentity = {
  federationId: string | null;
};

export type MemberSalesforceAccount = {
  id: string;
  accountNumber: string | null;
};

export type MemberAsset = {
  id: string;
  affiliation: Affiliation;
  status: AssetStatus;
  amountPaid: Partial<MonetaryValue> | null;
  activatedDate: string | null;
  effectiveAt: string | null;
  expireAt: string | null;
  omniOrderId: string | null;
  omniMembershipId: string | null;
  subscriptionStatus: string | null;
  paymentMethodId: string | null;
  product: Partial<HdcProduct>;
};

export type MonetaryValue = {
  amount: number;
  currency: string;
};

export type HdcProduct = {
  id: string;
  name: string | null;
  type: ProductType;
  code: string | null;
  price: Partial<MonetaryValue> | null;
  isVIP: boolean | null;
  level: number | null;
  omniInventoryId: string | null;
  skuCode: string | null;
  benefits: HdcProductBenefit[];
};

export type Benefit = {
  __typename: string;
  included: boolean;
};

export type RoadsideBenefit = Benefit & {
  towingDistance: number | null;
  amountCovered: number | null;
  vehicleType: VehicleType | null;
};

export type MagazineBenefit = Benefit & {
  issues: number | null;
};

export type HvtBenefit = Benefit;
export type EventsBenefit = Benefit;

export type HdcProductBenefit =
  | Partial<RoadsideBenefit>
  | Partial<MagazineBenefit>
  | Partial<HvtBenefit>
  | Partial<EventsBenefit>;

export enum Affiliation {
  HAGERTY,
  STFRM,
}

export enum AssetStatus {
  ACTIVE,
  EXPIRED,
  CANCELED,
  INACTIVE,
}

export enum ProductType {
  MEMBERSHIP,
  RADIUS,
}

export enum VehicleType {
  CLASSIC,
  HOUSEHOLD,
  COLLECTOR,
  ALLVEHICLES,
}
